import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Setting } from '../types/Setting';
 
interface SettingsState {
  settings: Setting[];
  settingsFetched: boolean;
}

const initialState: SettingsState = {
  settings: [],
  settingsFetched: false
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<Setting[]>) => {
      state.settings = action.payload;
      state.settingsFetched = true;
    },
  },
});

export const { setSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
